import { call, put, select, takeLatest } from 'redux-saga/effects'
import { HomeConstants } from '../../home/store/home.constants'
import { IPcr } from '../../pcr/store/pcr.types'
import { setActivityLog } from '../store/timeline.actions'
import { performWithMutexHOG } from '../../../services/mutexUtility.service'
import { PcrDocsService } from '../../../services/pcrDocs.service'
import { getPcrIdSelector } from '../../home/selectors'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { getServiceIdSelector } from '../../user/selectors'

export function* getTimelineItems(pcrDoc: IPcr) {
  const timelineItems = pcrDoc.patient?.timelineItems

  if (timelineItems && Object.keys(timelineItems).length !== 0) {
    yield put(setActivityLog(timelineItems))
  } else {
    yield put(setActivityLog([]))
  }
}

export function* preloadPCR() {
  const pcrID: string = yield select(getPcrIdSelector)
  const serviceId: string = yield select(getServiceIdSelector)
  if (!pcrID) return

  try {
    const pcrDocsService = new PcrDocsService(serviceId)
    const pcrDoc: IPcr = yield call([pcrDocsService, pcrDocsService.getPCR], pcrID)
    yield call(getTimelineItems, pcrDoc)
  } catch (e) {
    yield put(throwPcrException(`preloadPCR() error in getTimelineItems.saga.ts: ${e}`))
  }
}

export function* getTimelineItemsSaga() {
  yield takeLatest([HomeConstants.SET_NEW_PCR], performWithMutexHOG, preloadPCR)
}
